import { Model } from '@models/model';
import { SharingInfo } from '@models/sharingInfo';

export class SmsTemplate extends Model {
  idTemplate?: number;
  encoding: 'GSM' | 'UCS2';
  name: string;
  text: string;
  sender?: string;
  richUrl?: string;
  idPage?: number;
  sharingInfo?: SharingInfo;
}
